interface PropsType {
  width?: number;
  height?: number;
}

export default function BadgeIcon({ width = 10, height = 10 }: PropsType) {
  return <div style={{ width, height, background: '#F9A135', borderRadius: '50px' }} />;
}
